import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Referrer } from '../../classes/referrer';
import { ReferrerService } from '../../services/referrer';
import { AuthService } from '../../services/auth';
import { User } from '../../classes/user';
import { LinkedRequest } from '../../interfaces/referrer';

@Component({
    selector: 'app-referrer-detail',
    templateUrl: './referrer-detail.component.html',
    styleUrls: ['./referrer-detail.component.css']
})
export class ReferrerDetailComponent implements OnInit {
    user: User = new User();
    referrer: Referrer = new Referrer();
    loadError: string = '';

    constructor(private route: ActivatedRoute,
                private router: Router,
                private authService: AuthService,
                private referrerService: ReferrerService) {
    }

    ngOnInit(): void {
        this.authService.isUserSignedIn()
            .subscribe({
                next: () => {
                    this.authService.getUser()
                        .subscribe({
                            next: (user: any) => {
                                this.user = user;
                                if (this.user.FKIDUserRole !== 1) {
                                    this.router.navigate(['/dashboard']);
                                    return;
                                }
                                this.loadReferrer();
                            },
                            error: () => {
                                this.router.navigate(['/login']);
                            }
                        });
                },
                error: () => {
                    this.router.navigate(['/login']);
                }
            });
    }

    private loadReferrer(): void {
        this.route.paramMap.subscribe(params => {
            this.referrerService.getByID(params.get('id'))
                .subscribe({
                    next: (referrer: Referrer) => {
                        this.referrer = referrer;
                        this.loadError = '';
                    },
                    error: (err: HttpErrorResponse) => {
                        this.loadError = err.status === 404
                            ? 'Segnalatore non trovato.'
                            : 'Non è stato possibile caricare il segnalatore.';
                    }
                });
        });
    }

    get linkedRequests(): LinkedRequest[] {
        return this.referrer.requests || [];
    }

    customerLabel(request: LinkedRequest): string {
        const company = (request.customer?.CompanyName || '').trim();
        if (company) {
            return company;
        }
        const person = `${request.customer?.Name || ''} ${request.customer?.Surname || ''}`.trim();
        return person;
    }

    goToRequestDetail(idRequest: number | undefined) {
        if (idRequest == null) {
            return;
        }
        this.router.navigate(['/richiesta/' + idRequest]);
    }
}
